module.exports = __webpack_public_path__ + "static/media/filter.984ef54a.svg";